import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";

interface MenuItemProps {
  icon: React.ReactElement;
  text: string;
  linkTo: string;
}

const MenuItem: React.FC<MenuItemProps> = ({ icon, text, linkTo }) => {
  return (
    <ListItem>
      <Link to={linkTo} style={{ textDecoration: "none", color: "inherit" }}>
        <ListItemButton>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={text} />
        </ListItemButton>
      </Link>
    </ListItem>
  );
};

export default MenuItem;
